module.exports = __webpack_public_path__ + "img/NL512.136760f6.png";